export const uiTechDemo = {
    name: 'UI Tech Demo',
    description: '',
    displayField: 'markdown',
    fields: {
        markdown: {
            name: 'Markdown',
            type: 'Text',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        links: {
            name: 'Links',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['page'] }],
                linkType: 'Entry'
            }
        },
        textList: {
            name: 'Text List',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: { type: 'Symbol', validations: [] }
        },
        richText: {
            name: 'Rich Text',
            type: 'RichText',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    nodes: {
                        'entry-hyperlink': [{ linkContentType: ['route'] }],
                        'embedded-entry-block': [{ linkContentType: ['uiImage'] }],
                        'embedded-entry-inline': [{ linkContentType: ['uiTooltip'] }]
                    }
                }
            ]
        }
    }
};
//# sourceMappingURL=uiTechDemo.js.map